

















































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import Vuelidate from 'vuelidate';
import { required, minLength, between } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';

// import {SitesApi, Site, OrgsApi} from '../../../api';
import { Formula, FormulasApi, FormulaInput, FormulaInData } from '@/api';
import Toast from '@/components/display/toast.vue';
import { AxiosError } from 'axios';

@Component({
	components: {
		secondaryNav,
		vSelect,
		Toast,
	},
	validations: {
		form: {
			name: { required },
			formula: { required },
			inputs: { required },
			entityType: { required },
			sensorType: { required },
		},
	},
	mixins: [validationMixin],
})
export default class FormulaCreate extends Vue {
	public form = {
		name: '',
		formula: '',
		inputs: '',
		entityType: '',
		sensorType: '',
	};
	public errors = [];
	public $bvToast: any;
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	public entityTypes = ['tanks', 'vats', 'feed_tanks'];
	public sensorTypes = ['capacitance', 'distance', 'radarDistance'];

	constructor() {
		super();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const formula: FormulaInput = this.form;
		let createdFormula: Formula | undefined;

		try {
			const response = await new FormulasApi().addFormula({ data: formula });
			createdFormula = response.data.data;
		} catch (e) {
			const axiosError = e as AxiosError;
			let error;
			if (axiosError.response) {
				error = JSON.stringify(axiosError.response.data.errors, null, 2);
			} else {
				error = 'Formula not created, unknown error';
			}
			new Toast().makeToast(error, 'Error Creating Product', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Formula Added', 'Successfully Created', 'success');

		this.submitStatus = 'OK';

		setTimeout(() => {
			if (createdFormula) {
				this.$router.push({
					name: 'formulas.view',
					params: { formulaId: createdFormula.id.toString() },
				});
			}
		}, 1000);
	}
}
